import { I18nProvider } from '@lingui/react';
import ContactButton from './components/ContactButton';
import SidebarContext from './state/SidebarContext';
import { DataProps } from './types/uiTypes';
import NotOptedIn from './components/NotOptedIn';
import FiksFerdig from './components/FiksFerdig';
import getI18n from '../locales/loadTranslations';

const App = (props: DataProps) => {
    const {
        uiText,
        finnkode,
        isOwnAd,
        apiEndpoint,
        isPreviewMode,
        stylelink,
        lang,
        brand,
        device,
    } = props;
    const i18n = getI18n(lang);

    // When all else fail, at least show Communication teams' contact-button
    if (!uiText) return <ContactButton />;

    const { optedIn, notOptedIn } = uiText.sections.sidebar;

    const context = {
        finnkode,
        uiText,
        isOwnAd,
        apiEndpoint,
        isPreviewMode,
        urls: props.urls,
        brand,
        device,
    };

    return (
        <>
            <link href={stylelink} rel="stylesheet" type="text/css" />
            <I18nProvider i18n={i18n}>
                <SidebarContext.Provider value={context}>
                    {optedIn && <FiksFerdig />}
                    {notOptedIn && <NotOptedIn />}
                </SidebarContext.Provider>
            </I18nProvider>
        </>
    );
};
export default App;
